import $$ from 'dom7';
import * as moment from 'moment';
const PROGRAM_DAYS = 372;
export default {
  data: function () {
    let pillars = [{
      title: 'Pillar 1 "I Am Ready to Change"',
      points: 555,
      groups: 4
    }, {
      title: 'Pillar 2 "My Brain Can Change"',
      points: 530,
      groups: 5
    }, {
      title: 'Pillar 3 "I Am Not Ashamed"',
      points: 356,
      groups: 2
    }, {
      title: 'Pillar 4',
      points: 3,
      groups: 0
    }];
    return {
      daysSober: 0,
      points7Days: 0,
      progressDays: 1,
      progressPercent: 1 / PROGRAM_DAYS,
      pillars: modPillars(pillars)
    };
  },
  methods: {
    get7DayPoints: function () {
      let self = this;
      let points = 0;
      let sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
      self.$app.authPromise.then(() => {
        db.collection('entries').where('userId', '==', self.$app.data.user.uid).where('date', '>=', sevenDaysAgo).where('date', '<', moment().format('YYYY-MM-DD')).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let entry = doc.data();
            points += entry.points;
          });
          self.data.points7Days = points;
          self.$setState(self.data);
        }).catch(err => {
          console.error('could not get 7 day entries', err);
        });
      });
    },
    pointsPerPillar: function () {
      let self = this;
      let pillarsEl = $$('.pillars')[0];
      if (pillarsEl) pillarsEl.innerHTML = '';
      self.$app.authPromise.then(() => {
        let today = moment();
        let startDate = moment(self.$app.data.settings.programStartDate);
        let progressDays = today.diff(startDate, 'days');
        let pillarStats = [];
        let currentPillar = Math.ceil(progressDays / 31);
        let pillarStart = startDate;
        let promises = [];
        for (var i = 1; i <= currentPillar; i++) {
          let pillarEnd = pillarStart.clone().add(31, 'days');
          promises.push(db.collection('entries').where('userId', '==', self.$app.data.user.uid).where('date', '>=', pillarStart.format('YYYY-MM-DD')).where('date', '<', pillarEnd.format('YYYY-MM-DD')).get());
          pillarStart = pillarEnd;
        }
        promises.forEach((promise, i) => {
          let points = 0;
          let groups = 0;
          promise.then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              let entry = doc.data();
              points += entry.points;
              if (entry.therapyGroup) {
                groups += 1;
              }
            });
            pillarStats.push({
              pillar: i + 1,
              points,
              percet: points / 550,
              groups
            });
          }).catch(err => {
            console.error('could not get 7 day entries', err);
          });
        });
        Promise.all(promises).then(() => {
          pillarStats.sort((a, b) => {
            return a.pillar > b.pillar ? -1 : 1;
          });
          self.data.pillarStats = pillarStats;
          self.$setState(self.data);
          let $pillars = $$('.pillars');
          let $pillarTemplate = document.getElementById('pillar-template');
          pillarStats.forEach(pillar => {
            let percent = pillar.points / 550;
            let percentVal = pillar.points / 550;
            let percentText = (percent * 100).toFixed(1);
            let color = 'red';
            if (percentVal >= 0.5) {
              color = 'orange';
            }
            if (percentVal >= 0.9) {
              color = '#4caf50';
            }
            let template = $pillarTemplate.cloneNode(true);
            template.id = '';
            template.style.display = '';
            let blockTitle = template.querySelector('.block-title');
            if (blockTitle) blockTitle.textContent = `Pillar ${pillar.pillar} "${self.$app.data.pillars[pillar.pillar].title}"`;
            let pointsPoints = template.querySelector('.points-points');
            if (pointsPoints) pointsPoints.textContent = pillar.points;
            let pointsGroups = template.querySelector('.points-groups');
            if (pointsGroups) pointsGroups.textContent = pillar.groups;
            let gaugeHolder = template.querySelector('.gauge-holder');
            if (gaugeHolder) gaugeHolder.innerHTML = `<div class="gauge-${pillar.pillar}"></div>`;
            if ($pillars[0]) $pillars[0].appendChild(template);
            setTimeout(() => {
              let gauge = self.$app.gauge.create({
                el: `.gauge-${pillar.pillar}`,
                type: 'semicircle',
                value: percentVal,
                valueText: percentText + '%',
                valueTextColor: color,
                borderColor: color,
                labelText: 'of 550 points',
                labelTextColor: '#333'
              });
            }, 100);
            if ($pillarTemplate) $pillarTemplate.style.display = 'none';
          });
        });
      });
    }
  },
  on: {
    pageInit: function (e, page) {
      let self = this;
      if (self.data === undefined) {
        self.data = {};
      }

      // on tab show
      self.$app.on('tabShow', function (tabEl) {
        if (tabEl.id === 'view-stats') {
          self.pointsPerPillar();
          self.data.settings = self.$app.data.settings;
          let today = moment();
          self.data.progressDays = today.diff(moment(self.data.settings.programStartDate), 'days');
          self.data.progressPercent = self.data.progressDays / PROGRAM_DAYS;
          self.data.daysSober = self.$app.data.entries[0].daysSober;
          self.get7DayPoints();
          self.$setState(self.data);

          // update gauge
          let programGauge = self.$app.gauge.get('.program-gauge');
          programGauge.update({
            value: self.data.progressPercent,
            valueText: String(self.data.progressDays)
          });
        }
      });
    }
  },
  id: '9b81b3e14e',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=title>Statistics</div></div></div><div class=page-content><div class=list><ul><li><div class=item-content><div class=item-inner><div class=item-title>Number of Days Sober</div><div class="item-after text-color-black"><strong class=points>';
      r += c(ctx_1.daysSober, ctx_1);
      r += '</strong></div></div></div></li><li><div class=item-content><div class=item-inner><div class=item-title>Points Last 7 Days</div><div class="item-after text-color-black"><strong class=points>';
      r += c(ctx_1.points7Days, ctx_1);
      r += '</strong></div></div></div></li></ul></div><div class=block-title>Program Progress</div><div class="block block-strong"><div class="col text-align-center"><div class="gauge gauge-init program-gauge" data-type=semicircle data-value="';
      r += c(ctx_1.progressPercent, ctx_1);
      r += '" data-value-text="';
      r += c(ctx_1.progressDays, ctx_1);
      r += '" data-value-text-color=#4caf50 data-border-color=#4caf50 data-label-text="of 372 days" data-label-text-color=#333></div></div></div><div class=pillars></div><div class=pillar-template id=pillar-template><div class=block-title>Pillar #</div><div class="block block-strong"><div class=row><div class=col-30><div class=title-top>Points</div><div class="points points-points">###</div></div><div class="col-40 gauge-holder"></div><div class=col-30><div class=title-top>Groups</div><div class="points points-groups">#</div></div></div></div></div></div></div>';
      return r;
    }(this);
  },
  style: `
  .title-top {
    text-transform: uppercase;
    text-align: center;
  }
  .points {
    text-align: center;
    font-size: 200%;
  }
`,
  styleScoped: false
};
function modPillars(pillars) {
  pillars.forEach(pillar => {
    let percent = pillar.points / 550;
    pillar.percentVal = pillar.points / 550;
    pillar.percentText = (percent * 100).toFixed(1);
    pillar.color = 'red';
    if (pillar.percentVal >= 0.5) {
      pillar.color = 'orange';
    }
    if (pillar.percentVal >= 0.9) {
      pillar.color = '#4caf50';
    }
  });
  return pillars;
}